// Modules
import { Fragment, ReactElement } from 'react';

// Web Components
import { BiuDropdown } from '../../biu-web-components/src/components';

// Constants
import { constant } from '../../constants/contant';

// Types
import { Event } from '../../types/events';

import { useHistory } from 'react-router-dom';
import AddToCalendar from '../add-to-calendar/add-to-calendar.component';
import EventCheckout from '../event-checkout/event-checkout.component';
import EventContact from '../event-contact/event-contact.component';
import { MarginTop, MarginBottom } from '../../styles/common/space.styles';

const AdditionalInfo = ({
	event,
	lang,
	dir,
}: {
	event: Event;
	lang: string;
	dir: string;
}): ReactElement => {
	// Render
	return (
		<div>
			{event.cta.hasCta && (
				<EventCheckout lang={lang} dir={dir} event={event} />
			)}
			<MarginTop size={16} />
			<AddToCalendar event={event} lang={lang} />
			<MarginBottom size={16} />
			{event.contact.hasContact && (
				<EventContact lang={lang} dir={dir} event={event} />
			)}
		</div>
	);
};

export default AdditionalInfo;
